import { useTranslation } from '@klaviyo-mkt/gatsby-components/hooks/useTranslation';

import LinkButton from '@klaviyo-mkt/gatsby-components/atoms/button/variants/link';
import { generateClassName } from '@klaviyo-mkt/gatsby-components/shared/utils/functions';

import type { ILesson } from '../../../graphql/types';

import * as styles from './styles/lessonBottomNav.module.scss';

const LastLesson = (
  { collectionUrl }: { collectionUrl: string },
) => {
  const { t } = useTranslation();
  return !Boolean(collectionUrl) ?
    <LinkButton className={styles.link} text={t('academy_lesson_bottom_nav_catalog_label')}
                url={t('academy_search_href', { locale: 'en-us' })} variant="primary" /> :
    <LinkButton className={styles.link} text={t('academy_lesson_bottom_nav_collection_label')} url={collectionUrl}
                variant="primary" />;
};

const getCurrentLessonPagination = ({ lesson }: { lesson: ILesson }) => {
  // find current lesson and index
  const currentLesson = Array.isArray(lesson?.course?.lessons) &&
    lesson?.course?.lessons.find(({ pathId }) => pathId === lesson.pathId);
  const currentLessonIndex = Array.isArray(lesson?.course?.lessons) &&
  currentLesson ? lesson.course.lessons.indexOf(currentLesson) : -1;

  // next lesson and index
  const nextLessonIndex = currentLessonIndex > -1 ? currentLessonIndex + 1 : -1;
  const nextLesson = Array.isArray(lesson?.course?.lessons) && nextLessonIndex > 0
    ? lesson.course.lessons[nextLessonIndex] : null;

  // prevLesson and index
  const prevLessonIndex = currentLessonIndex > 0 ? currentLessonIndex - 1 : -1;
  const prevLesson = Array.isArray(lesson?.course?.lessons) && prevLessonIndex > -1
    ? lesson.course.lessons[prevLessonIndex] : null;

  // is current lesson last lesson
  const isLastLesson = Array.isArray(lesson?.course?.lessons) &&
    currentLessonIndex + 1 === lesson.course.lessons.length;

  return {
    prevLesson,
    nextLesson,
    isLastLesson,
  };
};

export const LessonBottomNav = ({
  collectionUrl = '',
  coursePath,
  lesson,
}: {
  collectionUrl?: string;
  coursePath: string;
  lesson: ILesson;
}) => {

  if (!lesson) return null;

  const {
    isLastLesson,
    prevLesson,
    nextLesson,
  } = getCurrentLessonPagination({ lesson });

  return (
    <div className={styles.lessonBottomNav}>
      {prevLesson && (<LinkButton className={styles.link} text="Previous" url={`${coursePath}/${prevLesson.pathId}`}
                                  variant="ghost" />)}
      <div className={generateClassName(['semibold', styles.courseTitle])}>{lesson.title}</div>
      {nextLesson && (<LinkButton className={styles.link} text="Next" url={`${coursePath}/${nextLesson.pathId}`}
                                  variant="primary" />)}
      {isLastLesson && <LastLesson collectionUrl={collectionUrl} />}
    </div>
  );
};
